<template>
  <span class="video-upload-wrap">
    <a-upload
      class="avatar-uploader"
      :show-upload-list="false"
      :before-upload="beforeUpload"
      :customRequest="customRequest"
    >
      <a-button><a-icon type="upload" /> 上传 </a-button>
    </a-upload>
    <span class="right">
      <a-progress :percent="progress" :status="status" size="small" />
      <a class="cancel" href="javascript:;" @click="onCancel">
        <span>取消</span>
      </a>
    </span>
  </span>
</template>

<script>
import { uploadMulti } from '@/api/upload'
import { getVideoDuration } from '@/utils/util'

export default {
  props: {
    max: {
      type: Number,
      default: 1
    },
    types: {
      type: Array,
      default: () => ['video/mp4', 'video/mov', 'video/avi', 'video/wmv']
    }
  },
  data() {
    return {
      progress: 0,
      status: null
    }
  },
  methods: {
    beforeUpload(file) {
      let { max, types } = this
      const isMatch = types.includes(file.type)
      if (!isMatch) {
        this.$message.error(`只能上传 ${types.join(', ')} 格式文件！`)
        return false
      }
      const isLtMax = file.size / 1024 / 1024 < max
      if (!isLtMax) {
        this.$message.error(`视频必须小于 ${max} MB!`)
        return false
      }
      this.$emit('input', file)
      return true
    },
    customRequest({ file }) {
      this.status = null
      uploadMulti(
        [file],
        val => {
          this.progress = val
        },
        { dir: 'course' }
      )
        .then(res => {
          const info = (res && res[0]) || {}
          getVideoDuration(file).then(len => {
            info.duration = len
            this.$emit('uploaded', info)
          })
        })
        .catch(err => {
          this.$message.error(`上传失败: ` + (err || {}).message)
          this.progress = 0
          this.status = 'exception'
        })
    },
    onCancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="less" scoped>
.video-upload-wrap {
  display: inline-block;
  .right {
    display: inline-block;
    margin-left: 10px;
    width: 180px;
    position: relative;
    .cancel {
      position: absolute;
      display: inline-block;
      width: 50px;
      top: 3px;
    }
  }
}
</style>
